// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import { addListener, removeListeners } from "~/lib/signals";
import { store } from "~/state/store";
import ContentOverlay from "~/content.overlay";
import { _ } from "~/i18n";
import { watch, watchMapset } from "~/state/util";
import { Unsubscribe } from "redux";

const CONTENTS = {
	zakladni: {
		trans: "legend-turistnew"
	},
	letni: {
		trans: "legend-summer"
	},
	turisticka: {
		trans: "legend-turistnew"
	},
	zimni: {
		trans: ["legend-winter", "legend-krkonose"]
	},
	"19stoleti": {
		trans: "legend-history"
	},
	zemepisna: {
		trans: "legend-geographical"
	},
	fotografie: {
		trans: "legend-turistnew"
	}
};

export default class Legend extends ContentOverlay {
	_storeUnsubscribe: Unsubscribe;

	constructor() {
		super();

		this._contentName = "legend";
		this._dom = {
			container: node("div", {id:"legend", className: "legends"}),
			img: node("img",{alt: "", src: ""})
		};

		this._es = [];
		this._langOrders = null;

		this._buildCloseButton();

		const wt = watch(store.getState, "map", watchMapset);

		this._storeUnsubscribe = store.subscribe(wt(() => {
			this._build();
		}));
	}

	show() {
		Mapy.getComponent("layout").setWidth(1);
		Mapy.CML.state = {
			route: {
				showGeometries: true
			}
		};
		return super.show();
	}

	hide() {
		Mapy.CML.state = {
			route: {
				showGeometries: false
			}
		};
		return super.hide();
	}

	getContainer(){
		return this._dom.container;
	}

	handleEvent(e) {
		if (e.type == "keydown") {
			if (e.keyCode == 27) { /* esc */
				e.preventDefault();
				this.deactivate();

				Mapy.getComponent("history").save();
			}
		}
	}

	activate() {
		super.activate();

		this._load().then(() => {
			this._build();

			this._es.push(addListener(this, "detail-activated", "deactivateFromSignal"));
			this._es.push(addListener(this, "route-response", "deactivateFromSignal"));
			this._es.push(addListener(this, "change-user-marks", "deactivateFromSignal"));
			this._es.push(addListener(this, "change-distancemeter-item", "deactivateFromSignal"));

			window.addEventListener("keydown", this, false);
		}, () => {});

		return this;
	}

	deactivate() {
		this._removeCloseButton();
		removeListeners(this._es);

		window.removeEventListener("keydown", this, false);

		return super.deactivate();
	}

	deactivateFromSignal() {
		this.deactivate();
	}

	_build() {
		if (!this.isActive() || !this._langOrders) { return; }

		const { mapset } = store.getState().map;
		var all = Object.keys(CONTENTS);
		var find;

		all.every(function(key) {
			if (key == mapset) {
				find = CONTENTS[key];
				return false;
			}
			else return true;
		}, this);

		if (!find) {
			// prvni, zakladni sada
			find = CONTENTS["zakladni"];
		}

		this._dom.container.innerHTML = "";

		var abbr = [];
		var trans = Array.isArray(find.trans) ? find.trans : [find.trans];
		trans.forEach(function(transKey) {
			var isKrkonose = transKey == "legend-krkonose";
			var setName = transKey.replace("legend-", "");

			if (isKrkonose) {
				var title = node("h3", { innerHTML: _("legend.krkonoseTitle") });

				this._dom.container.appendChild(title);
			}
			else {
				for (var i = 0; i < this._langOrders["legend-abbr"].length; i++) {
					var item = this._langOrders["legend-abbr"][i];

					if (item.set.indexOf(setName) != -1) {
						var abbrTrans = _("legend-abbr:abbr." + item.name);

						if (abbrTrans) {
							abbr.push({
								name: item.name,
								value: abbrTrans
							});
						}
					}
				}
			}

			// upravy pro dopravni mapu
			if (mapset == "dopravni") {
				var trafficEl = this._createLegend("legend-traffic", 1);
				this._dom.container.appendChild(trafficEl);
			}

			var el = this._createLegend(transKey, isKrkonose ? 2 : 1);
			this._dom.container.appendChild(el);
		}, this);

		// vytvoreni zkratek
		if (abbr.length) {
			var title = node("h3", { className: "abbr", innerHTML: _("legend-abbr:name") });
			var table = node("table", { className: "abbr-table" });
			var tbody = node("tbody");

			table.appendChild(tbody);

			abbr.forEach(function(short) {
				var line = node("tr");
				var name = node("td", { innerHTML: short.name });
				var trans = node("td", { innerHTML: short.value });

				line.appendChild(name);
				line.appendChild(trans);
				tbody.appendChild(line);
			});

			this._dom.container.appendChild(title);
			this._dom.container.appendChild(table);
		}
	}

	_createLegend(transKey, columns) {
		var table = document.createElement("table");
		table.classList.add(transKey);

		columns = columns || 1;

		var legendKeys = this._langOrders[transKey].split("|");
		var tr;

		legendKeys.forEach(function(legKey, ind) {
			var item = this._createLegendItem(transKey, legKey);
			var ptr = ind % columns;

			if (ptr === 0) {
				tr = document.createElement("tr");
			}

			tr.appendChild(item[0]);
			tr.appendChild(item[1]);

			if (ptr === 0) {
				table.appendChild(tr);
			}
		}, this);

		return table;
	};

	_createLegendItem(transKey, legKey) {
		var td = document.createElement("td");
		td.classList.add("icon-cover");
		var td2 = document.createElement("td");
		td2.classList.add("trans");

		td.innerHTML = "<span class='" + legKey + "'></span>";

		td2.innerHTML = _(transKey + ":" + legKey);

		return [td, td2];
	};

	getState() {
		return {lgnd: 1};
	}

	setState(data) {
		if (data.lgnd) {
			this.activate();
		}
		else {
			this.deactivate();
		}
	}

	async _load() {
		if (!this._langOrders) {
			Mapy.getComponent("loader").start(true);

			const moduleImport = await import(
				/* webpackChunkName: "langOrders" */
				'~/langOrders'
			);

			this._langOrders = moduleImport.LangOrders;

			Mapy.getComponent("loader").end(true);
		}
	}
}
